import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { UPDATE_PLACE } from 'src/api/places.api';
import type { UpdatePlace, UpdatePlaceVariables } from 'types/graphql';

/** `updatePlace` on the UpdatePlace document; the caller's options (toasts, refetches) pass through untouched. */
export function useUpdatePlace(options?: MutationHookOptions<UpdatePlace, UpdatePlaceVariables>) {
  const [mutate, { loading, error }] = useMutation<UpdatePlace, UpdatePlaceVariables>(UPDATE_PLACE, options);
  const update = useCallback(({ id, input }: UpdatePlaceVariables) => mutate({ variables: { id, input } }), [mutate]);
  return { update, loading, error };
}
